// import api's and mutations
import { getVersionHistory } from 'RestAPIs/version-history';

// import components
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

// import hooks
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { RecoilRoot } from 'recoil';

// import utils
import { formatByLocale, fromISOString } from 'utils/date';

function DeployHistory() {
  const { t } = useTranslation();

  const { data: versionHistory = [] } = useQuery(
    ['VersionHistory'],
    async ({ signal }) => {
      const { data } = await getVersionHistory({ signal });
      return data;
    },
    {}
  );

  const rows = versionHistory.map((o) => ({
    ...o,
    deployedDate: fromISOString(o.deployed),
    deployed: formatByLocale(fromISOString(o.deployed), 'Pp')
  }));
  const columns = ['version', 'deployed'];

  const baseColumns = columns.map((key) => ({
    field: key,
    headerName: t(`deployHistory.${key}`),
    flex: 1
  }));

  return <TableCRUDLayout rows={rows} columns={baseColumns} editable={false} />;
}

export default function DeployHistoryRoot() {
  return (
    <RecoilRoot>
      <DeployHistory />
    </RecoilRoot>
  );
}
